import { useDispatch, useSelector } from "react-redux";
import { ActionGroupTypes } from "../../../abstract/controller/enum/ActionStatusTypes";
import { getHistory, rewindHistory } from "../../../abstract/redux/slice/structureSlice";
import DefaultTooltip, * as vendorTooltip from "../../ui/tooltips/DefaultTooltip";
import styles from "./AsideElementHistory.module.scss";
import IconBxsDownArrow from "../../../themes/icons/IconBxsDownArrow";
import IconBxsRightArrow from "../../../themes/icons/IconBxsRightArrow";
import { useState } from "react";

function AsideElementHistory() {
  const _history = useSelector(getHistory);

  return (
    <div className={styles["history"]}>
      <div className={styles["history__header"]}>actions</div>
      <SectionActions history={_history} />
    </div>
  );
}

const SectionActions = ({ history }) => {
  const [hidden, setHidden] = useState(() => new Set());

  const handleAddHidden = (collection) => {
    const newFolded = new Set([...hidden, ...collection]);

    setHidden(newFolded);
  };

  const handleRemoveHidden = (collection) => {
    const newFolded = new Set([...hidden]);

    collection.forEach((e) => {
      newFolded.delete(e);
    });

    setHidden(newFolded);
  };

  return (
    <div className={styles["history__list"]}>
      {history.map((e) => (
        <div key={e.time}>
          {!hidden.has(e.time) && (
            <ContainerAction
              action={e}
              addHidden={handleAddHidden}
              removeHidden={handleRemoveHidden}
            />
          )}
        </div>
      ))}
    </div>
  );
};

const ContainerAction = ({ action, addHidden, removeHidden }) => {
  const _dispatch = useDispatch();

  const _index = action.index;
  const _time = action.time;
  const _children = action.children;
  const _description = action.description;
  const _revert = action.rewind;

  const [folded, setFolded] = useState(false);

  const handleShowFolded = () => {
    if (folded) {
      setFolded(false);
      removeHidden(_children);
    } else {
      setFolded(true);
      addHidden(_children);
    }
  };

  const handleOnClickItem = () => {
    if (_revert) {
      _dispatch(rewindHistory(_time));
      removeHidden(_children);
    } else {
      _dispatch(rewindHistory(_time));
    }
  };

  const getTextColor = (action) => {
    if (action.inactive > 0) {
      return "color--inactive";
    }

    switch (action.group) {
      case ActionGroupTypes.ADD:
        return "color--green";
      case ActionGroupTypes.DELETE:
      case ActionGroupTypes.REVERT:
        return "color--red";
      case ActionGroupTypes.UPDATE:
        return "color--neutral";
      default:
        return "";
    }
  };

  return (
    <>
      <div
        className={`${styles["history__list__item"]} ${styles[getTextColor(action)]}`}
        data-tooltip-id={`tooltip-action-${_time}`}
        data-tooltip-delay-show={vendorTooltip.getTimeFast()}>
        <div className={styles["history__list__icon"]} onClick={handleShowFolded}>
          {_children.length > 0 && !_revert && (
            <>{folded ? <IconBxsRightArrow /> : <IconBxsDownArrow />}</>
          )}
        </div>
        <span className={styles["history__list__header"]} onClick={handleOnClickItem}>
          {_index}) {_description}
        </span>
      </div>
      <DefaultTooltip handle={`tooltip-action-${_time}`}>{_description}</DefaultTooltip>
    </>
  );
};

export default AsideElementHistory;
